<template>
  <div>
    <vs-alert :active.sync="errorOccurred" color="danger" title="Error While Loading Course">
      <span>We were unable to load Course with Id {{ $route.params.courseId }} successfully.</span>
    </vs-alert>
    <div v-if="!errorOccurred">

      <div v-if="courseData">
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vx-card>
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <img class="mr-4 rounded" :src="courseData.thumbnail" v-if="courseData.thumbnail" width="40" height="40">
                  <h1 class="">{{ courseData.name }}</h1>
                </div>
                <div class="flex justify-end items-center">
                  <feather-icon v-if="autoSave.status === 'success'" icon="CheckIcon" svgClasses="h-5 w-5 text-success mr-2"/>
                  <div v-else-if="autoSave.status === 'pending'" class="vs-con-loading__container h-5 w-5 mr-2" id="pendingLoadingCircle"/>
                  <feather-icon v-else icon="XCircleIcon" svgClasses="h-5 w-5 text-danger mr-2"/>
                  <p class="cursor-pointer" @click="saveChanges">{{ autoSave.text }}</p>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
        <div class="vx-row" v-if="courseDomains">
          <div class="vx-col w-2/3">
            <vx-card>
              <div v-if="!isCourseDomainsEmpty || dragging === true">
                <h1 class="my-6 font-bold text-center" v-if="isCourseDomainsEmpty && dragging === true">Drop Domain Here</h1>
              <draggable :list="courseDomains" :group="{name: 'domains'}" class="cursor-move"  @change="saveChanges" style="min-height: 15rem">
              <div v-for="(domain, index) in courseDomains" :class="domainShowSets ? 'mb-1' : 'border-white border-solid p-2 rounded mb-3'">
                <div class="flex justify-between items-center p-2">
                  <h4 class="font-light">{{ domain.name }}</h4>
                  <div class="flex justify-end items-center">
                    <vs-button size="small" color="warning" type="gradient" class="cursor-pointer mr-2"
                               icon-pack="feather" icon="icon-edit" @click="">
                      Edit
                    </vs-button>
                    <vs-button size="small" color="primary" type="gradient" class="cursor-pointer mr-2"
                               icon-pack="feather" icon="icon-layout" @click="$router.push(`/a/domains/${domain.id}/builder`)">
                      Domain Builder
                    </vs-button>
                    <vs-button size="small" color="danger" type="gradient" class="cursor-pointer"
                               icon-pack="feather" icon="icon-trash" @click="removeDomainFromCourse(index)">
                      Delete
                    </vs-button>
                  </div>
                </div>
                <div v-if="domainShowSets" class="mt-2 mb-6 p-6 rounded-lg" style="background-color: rgba(0,0,0,0.15)">
                  <div class="grid grid-cols-5 gap-5">
                    <div class="flex items-center justify-center cursor-pointer" v-for="(set, index) in domain.sets">
                      <div class="p-1" @mouseover="lottiePlay(`setStarter${set.id}_${index}`)"
                           @mouseleave="lottieStop(`setStarter${set.id}_${index}`)">
                        <radial-progress-bar :diameter="115" :completed-steps="currentStep" :total-steps="totalSteps"
                                             :animateSpeed="1100" timingFunc="ease"
                                             :innerStrokeColor="setColorProgress" startColor="#0cdc62" stopColor="#0cdc62"
                                             :strokeWidth="7" :innerStrokeWidth="7">
                          <div class="flex items-center justify-center">
                            <div class="con-vs-avatar bg-transparent" style="width: 75px; height: 75px">
                              <div class="con-img vs-avatar--con-img flex items-center justify-center">
                                <lottie-animation
                                  :path="set.lottie" :ref="`setStarter${set.id}_${index}`"
                                  :loop="true" :autoPlay="false" :speed="1" :width="60"/>
                              </div>
                            </div>
                          </div>
                        </radial-progress-bar>
                        <h5 class="font-bold text-center mt-3">{{ set.name }}</h5>
                        <div class="flex items-center justify-center mt-3">
                          <vs-button color="danger" type="gradient" size="small" @click="$router.push(`/a/sets/${set.id}/builder`)">Set Builder</vs-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </draggable>
              </div>
              <div v-if="isCourseDomainsEmpty && dragging === false">
                <div class="flex items-center justify-center">
                  <lottie-animation
                    path="https://assets3.lottiefiles.com/packages/lf20_1iNByG.json"
                    :loop="true" :autoPlay="true" :speed="1" :width="300"/>
                </div>
                <h1 class="font-bold text-center mt-4">Its Lonely In Here</h1>
                <h5 class="text-light text-center mt-2 mb-4">To Add Domains Drag Them Into This Box</h5>
              </div>
            </vx-card>
          </div>
          <div class="vx-col w-1/3">
            <vx-card class="mb-4">
              <h4>Domain Bank</h4>
              <vs-input v-model="domainSearch" @input="fetchDomainList" class="my-4 mt-5 w-full "
                        placeholder="Domain Search"/>
              <vs-list class="p-0 mt-3" v-if="domainList.length !== 0">
                <draggable :list="domainList" :group="{name:'domains',  pull:'clone', put:false }" :sort="false" :move="checkMove"
                           class="cursor-move" @start="dragging = true" @end="dragging = false">
                  <vs-list-item v-for="(listItem) in domainList" :key="listItem.id" :title="listItem.name"
                                :subtitle="listItem.id">
                    <vs-avatar slot="avatar" :src="listItem.thumbnail" class="mr-3"/>
                  </vs-list-item>
                </draggable>
              </vs-list>
              <p class="mt-2 p-1" v-else>No Records Found</p>
            </vx-card>
            <vx-card >
              <vs-button :color="domainShowSets ? 'danger' : 'success'" class="w-full"
                         icon-pack="feather" :icon="domainShowSets ? 'icon-eye-off' : 'icon-eye'"
                         @click="domainShowSets = !domainShowSets">
                {{ domainShowSets ? 'Hide Domain Sets' : 'Show Domain Sets' }}
              </vs-button>
            </vx-card>
          </div>

        </div>
      </div>

      <div v-else class="simple-spinner">
        <span></span>
      </div>


    </div>
  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'
import LottieAnimation from '@/components/lottie/LottieAnimation'
import draggable from 'vuedraggable'

export default {
  data () {
    return {
      courseData: null,
      courseDomains: null,

      domainList: [],
      domainSearch: '',
      domainShowSets: false,

      dragging: false,

      setList: [],

      totalSteps: 5,
      currentStep: 0,

      autoSave: {
        status: 'success',
        text: 'Ready To Save'
      },

      errorOccurred: false

    }
  },
  computed: {
    setColorProgress () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgba(0,0,0,0.2)'
      if (theme === 'midnight') return 'rgba(0,0,0,0.5)'
      if (theme === 'dark') return 'rgba(0,0,0,0.2)'
    },
    isCourseDomainsEmpty () {
      return this.courseDomains.length === 0
    }
  },
  components: {
    RadialProgressBar,
    LottieAnimation,
    draggable
  },
  methods: {
    fetchCourseDetails (id) {
      this.$http.get(`courses/${id}?rich=true`)
        .then(response => {
          if (response.status === 200) {
            this.courseData = response.data.data
            this.courseDomains = response.data.data.domains
            this.fetchDomainSets()
          }
        }).catch(() => {
        })
    },
    fetchDomainSets () {
      this.courseDomains.forEach((domain, index) => {
        this.$http.get(`domains/${domain.id}?rich=true`)
          .then(response => {
            if (response.status === 200) {
              this.courseDomains[index] = response.data.data
            }
          })
          .catch(() => {
            this.errorOccurred = true
          })
      })
    },
    fetchDomainList () {
      this.$http.get(`domains?search=${this.domainSearch}&amount=5&rich=true`)
        .then(response => {
          if (response.status === 200) {
            this.domainList = response.data.data
          }
        }).catch(() => {
        })
    },
    lottiePlay (ref) {
      this.$refs[ref][0].play()
    },
    lottieStop (ref) {
      this.$refs[ref][0].stop()
    },
    removeDomainFromCourse (index) {
      this.courseDomains.splice(index, 1)
    },
    checkMove (evt) {
      let move = true
      this.courseDomains.forEach(domain => {
        if (domain.id === evt.draggedContext.element.id) move = false
      })
      return move
    },
    saveChanges () {

      this.autoSave = {
        text: 'Saving...',
        status: 'pending'
      }

      setTimeout(() => {
        this.$vs.loading({
          color: '#FF9F43',
          background: 'transparent',
          container: '#pendingLoadingCircle',
          scale: 0.325,
          type: 'point'
        })
      }, 1)

      const pl = []
      this.courseDomains.forEach(domain => {
        pl.push(domain.id)
      })
      this.$http.post(`courses/${this.courseData.id}`, {domains : pl})
        .catch(() => {
          this.$vs.loading.close('#pendingLoadingCircle> .con-vs-loading')
          return this.autoSave = {
            text: 'Error While Saving Changes',
            status: 'error'
          }
        })

      setTimeout(() => {
        this.$vs.loading.close('#pendingLoadingCircle> .con-vs-loading')
        const date = new Intl.DateTimeFormat('en-US', {hour: 'numeric', minute: 'numeric', second: 'numeric'})
        this.autoSave = {
          text: `All Changes Saved - ${date.format(new Date())}`,
          status: 'success'
        }
      }, 1500)
    }
  },
  created () {
    this.fetchCourseDetails(this.$route.params.courseId)
    this.fetchDomainList()

    setTimeout(() => {
      this.currentStep = 1
    }, 1500)
  }


}
</script>

<style scoped>

</style>
